module.exports = __webpack_public_path__ + "static/img/12.32d3f11.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/eng/12.png
// module id = EIiG
// module chunks = 0